import React, { useState } from 'react';
import './style.css';
import { Button } from 'antd';
import type { FormInstance } from 'antd/es/form';
import LayoutComponent from '../../coreComponents/LayoutComponent';
import ChatFeatures from '../../coreComponents/ChatFeatures';
import CallFeatures from '../../coreComponents/CallFeatures';

/**
 * Props for the LeftSideBar component.
 */
interface LeftSideBarProps {
  /** Ant Design form instance for managing form state. */
  form: FormInstance;
}

/**
 * LeftSideBar component provides navigation to switch between layout, chat, and call features.
 *
 * @param {LeftSideBarProps} props - Component props.
 * @returns {JSX.Element} The rendered LeftSideBar component.
 */
const LeftSideBar = ({ form }: LeftSideBarProps) => {
  const [activeComponent, setActiveComponent] = useState('layout');

  /**
   * Renders the corresponding component based on the active selection.
   *
   * @returns {JSX.Element} The selected component to be displayed.
   */
  const renderDynamicComponent = () => {
    switch (activeComponent) {
      case 'layout':
        return <LayoutComponent form={form} />;
      case 'chat':
        return <ChatFeatures form={form} />;
      case 'call':
        return <CallFeatures form={form} />;
      default:
        return <LayoutComponent form={form} />;
    }
  };

  return (
    <div id="leftSideBarWrapper" className="leftSideBarWrapper">
      <div className="menuBarWrapper">
        <div className="menuBar">
          <Button
            className="menuBarButton layoutButton"
            style={{
              background: activeComponent === 'layout' ? '#6852D6' : '',
            }}
            onClick={() => setActiveComponent('layout')}
            icon={
              <div
                className="menuBarButtonIcon layoutButtonIcon"
                style={{
                  background: activeComponent === 'layout' ? 'white' : '',
                }}
              />
            }
          />
          <Button
            className="menuBarButton chatButton"
            style={{
              background: activeComponent === 'chat' ? '#6852D6' : '',
            }}
            onClick={() => setActiveComponent('chat')}
            icon={
              <div
                className="menuBarButtonIcon chatButtonIcon"
                style={{
                  background: activeComponent === 'chat' ? 'white' : '',
                }}
              />
            }
          />
          <Button
            className="menuBarButton callButton"
            style={{
              background: activeComponent === 'call' ? '#6852D6' : '',
            }}
            onClick={() => setActiveComponent('call')}
            icon={
              <div
                className="menuBarButtonIcon callButtonIcon"
                style={{
                  background: activeComponent === 'call' ? 'white' : '',
                }}
              />
            }
          />
        </div>
      </div>

      <div className="chatOptions">{renderDynamicComponent()}</div>
    </div>
  );
};

export default LeftSideBar;
